const zonas = {
    GuardarNuevaZona: 'SINOJ/Zonas/GuardarNuevaZona',
    ObtenerZonas: 'SINOJ/Zonas/ObtenerZonas',
    EliminarZona: 'SINOJ/Zonas/EliminarZona',
    EditarZona: 'SINOJ/Zonas/EditarZona'
}

const notificadores = {
    GuardarNuevoNotificador: 'SINOJ/Notificadores/GuardarNuevoNotificador',
    ObtenerNotificadores: 'SINOJ/Notificadores/ObtenerNotificadoresRegistrados',
    EliminarNotififcador: 'SINOJ/Notificadores/EliminarNotificador',
    EditarNotififcador: 'SINOJ/Notificadores/EditarNotificador'
}

const fraccionamientos = {
    GuardarNuevoFraccionamiento: 'SINOJ/Fraccionamientos/GuardarNuevoFraccionamiento',
    GuardarFraccionamientos: 'SINOJ/Fraccionamientos/GuardarFraccionamientos',
    EliminarFraccionamiento: 'SINOJ/Fraccionamientos/EliminarFraccionamiento',
    EditarFraccionamiento: 'SINOJ/Fraccionamientos/EditarFraccionamiento',
    ObtenerFraccionamientosRegistrados: 'SINOJ/Fraccionamientos/ObtenerFraccionamientosRegistrados',
    GuardarAsignaciones: 'SINOJ/Fraccionamientos/GuardarAsignaciones',
    EliminarAsignaciones: 'SINOJ/Fraccionamientos/EliminarAsignaciones'
}

const empresas = {
    GuardarNuevaEmpresa: 'SINOJ/Empresas/GuardarNuevaEmpresa',
    EliminarEmpresa: 'SINOJ/Empresas/EliminarEmpresa',
    GuardarAsignacionesANotificador: 'SINOJ/Empresas/GuardarAsignacionesANotificador',
    CambiarEstatusDeEmpresas: 'SINOJ/Empresas/CambiarEstatusDeEmpresas'
}

const plantillas = {
    GuardarNuevaPlantilla: 'SINOJ/Plantillas/GuardarNuevaPlantilla',
    ModificarPlantilla: 'SINOJ/Plantillas/ModificarPlantilla',
    EliminarPlantilla: 'SINOJ/Plantillas/EliminarPlantilla'
}

const administracion = {
    zonas: zonas,
    notificadores: notificadores,
    fraccionamientos: fraccionamientos,
    empresas: empresas,
    plantillas: plantillas
}

export default administracion;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SINOJ/sistema/administracion/administracion.js
// module id = null
// module chunks = 